import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-4 is-size-4" }
const _hoisted_2 = {
  key: 0,
  class: "p-4 columns is-multiline is-justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_compare_fonts = _resolveComponent("compare-fonts")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["survey-item fade-in", { 'fade-out': _ctx.isFadeOut }])
      }, [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.titleWord), 1),
        (_ctx.isChildVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.compareFontItems.length)
                ? (_openBlock(), _createBlock(_component_compare_fonts, {
                    key: 0,
                    fontItems: _ctx.compareFontItems,
                    surveySentence: _ctx.surveySentence,
                    onVote: _ctx.vote
                  }, null, 8, ["fontItems", "surveySentence", "onVote"]))
                : (_ctx.selectedFontItem.length)
                  ? (_openBlock(), _createBlock(_component_compare_fonts, {
                      key: 1,
                      fontItems: _ctx.selectedFontItem,
                      surveySentence: _ctx.surveySentence,
                      onVote: _ctx.reVote
                    }, null, 8, ["fontItems", "surveySentence", "onVote"]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}